// export const Construct_code_category = [
//   { construct: "Academic Burden", code: "bur", category: "Student Beliefs" },
//   { construct: "Withdrawal Intention", code: "with", category: "Learning Behaviors" },
//   { construct: "Self-Efficacy", code: "se", category: "Student Beliefs" },
//   { construct: "Value", code: "val", category: "Student Beliefs" },
//   { construct: "Intrinsic Motivation", code: "amot", category: "Student Beliefs" }, // or autonomous motivation? 
//   { construct: "Extrinsic Motivation", code: "cmot", category: "Student Beliefs" }, // or controlled motivation?
//   { construct: "Behavioral Engagement", code: "beh", category: "Learning Behaviors" },
//   { construct: "Cognitive Engagement", code: "cog", category: "Learning Behaviors" },
//   { construct: "Affective Engagement", code: "aff", category: "Learning Behaviors" },
//   { construct: "Self-Regulation", code: "srt", category: "Learning Behaviors" },
//   { construct: "Autonomy", code: "aut", category: "Classroom Context" },
//   { construct: "Relatedness", code: "rel", category: "Classroom Context" },
//   { construct: "Cultural Congruity", code: "cult", category: "Classroom Context" },
//   { construct: "Belongingness", code: "bel", category: "Classroom Context" }, // or perceived belonging?  
// ];

export const Construct_code_category = [
  { construct: "Confidence", code: "con", category: "Student Learning" },
  { construct: "Student Habits", code: "sth", category: "Student Learning" },
  { construct: "Stress", code: "abur", category: "Student Learning" },
  { construct: "Motivation", code: "mot", category: "Student Learning" },
  { construct: "Resilience", code: "res", category: "Student Learning" },
];

export const studentAliasMap = {
  // "Zariel Galaviz": "Theon Greyjoy",
  // "Liat Aberman": "Tyrion Lannister",
  // "Kayden Jones": "Stannis Baratheon",
  // "Alayna Smith": "Ygritte",
  // "Britney Johnston": "Arya Stark",
  // "Jaelinjoy Chavez": "Brienne Tarth",
  // "Shawn Anthony Collado": "Jaime Lannister",
  // "Lana Wilson": "Cersei Lannister",
  // "Leya Dow": "Jon Snow",
  // "Adrienne Bautista": "Sansa Stark",
  // "Octavio Varela Segovia": "Eddard Stark",
  "Zoie Becker": "Neville Longbottom",
  "Eric Falcon Ledezma": "Luna Lovegood",
  "Tamiyah Hill": "Ginny Weasley",
  "Monica Pacheco": "Harry Potter",
  "Alec Plotegher": "Ron Weasley",
  "Wangtianjiao Cheng": "Hermione Granger",
  "Amya Johnson-Turpin": "Draco Malfoy",
};